import type { CharacterId } from '../content/characters';

export const PROFILE_AVATARS: readonly CharacterId[] = [
  'weak-stone', 'proliferation-stone', 'breeding-stone', 'strong-stone', 'revival-stone',
  'grass-stone', 'water-stone', 'fire-stone', 'lightning-stone', 'ghost-stone',
  'afterimage-stone', 'sacrifice-stone', 'corpse-stone', 'hyperactive-stone', 'extreme-hyperactive-demon',
  'escape-stone', 'robot-vacuum-stone', 'glutton-stone', 'will-hunter-king', 'labor-stone',
  'salvation-god', 'destruction-dragon', 'ultimate-reversal-dragon', 'ultimate-labor-god',
  'ultimate-hyperactive-god', 'ultimate-destruction-god', 'sniper-stone', 'shinra-bansho-god',
  'causality-erasure-god-stone', 'board-logic-observer',
];

export type ProfileStats = Readonly<{ runs: number; clears: number; maxChain: number; maxStage: number; playTimeMs: number }>;
export type PlayerProfile = Readonly<{
  name: string | null; avatarId: CharacterId; bio: string; playerId: string | null;
  createdAt: number | null; hasRecoveryCode: boolean; stats: ProfileStats;
}>;
export type ProfileEdit = Readonly<{ name: string; avatarId: CharacterId; bio: string }>;
export const EMPTY_PROFILE: PlayerProfile = {
  name: null, avatarId: 'weak-stone', bio: '', playerId: null, createdAt: null, hasRecoveryCode: false,
  stats: { runs: 0, clears: 0, maxChain: 0, maxStage: 1, playTimeMs: 0 },
};

export function isProfileAvatar(value: unknown): value is CharacterId {
  return typeof value === 'string' && PROFILE_AVATARS.includes(value as CharacterId);
}

export function normalizeProfileBio(value: unknown): string | null {
  if (typeof value !== 'string') return null;
  const bio = value.replace(/\r\n?/g, '\n').trim();
  if (Array.from(bio).length > 120 || /[\u0000-\u0009\u000b-\u001f\u007f\p{Cf}]/u.test(bio)) return null;
  return bio;
}

export function normalizeRecoveryCode(value: unknown): string | null {
  if (typeof value !== 'string') return null;
  const code = value.trim().toUpperCase().replace(/[\s-]/g, '');
  return /^ISHI[0-9A-F]{40}$/.test(code) ? code : null;
}
